module.exports = __webpack_public_path__ + "img/logo-app-white.62d6b96e.svg";